import { createQueryKeys } from "@lukemorales/query-key-factory";

import {
  ConsultationLinksParams,
  listInvitationLinks,
} from "../api/consultationLinks";

export const invitationLinksQueryOptionsFactory = createQueryKeys(
  "invitation-links",
  {
    list: (listInvitationLinksRequest: ConsultationLinksParams) => ({
      queryKey: [{ listInvitationLinksRequest }],
      queryFn: () => listInvitationLinks(listInvitationLinksRequest),
    }),
  },
);
